// Best-time-to-post helpers (Buffer-parity item 5). The broker derives
// suggestions from the facility's own engagement history and refuses to
// suggest below its data threshold — render its honesty, don't paper over it.
import { distributionFetch } from "./api";

const DAY_NAMES = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

export const loadBestTimes = (facilityId) => {
  const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  return distributionFetch(
    `/best-times/${facilityId}?tz=${encodeURIComponent(tz)}`,
  );
};

const hourLabel = (h) => {
  const ampm = h < 12 ? "am" : "pm";
  const display = h % 12 === 0 ? 12 : h % 12;
  return `${display}${ampm}`;
};

// "Tue 9am–12pm" — slots are 3-hour blocks in the requested timezone.
export const slotLabel = (slot) =>
  `${DAY_NAMES[slot.day_of_week]} ${hourLabel(slot.hour)}–${hourLabel((slot.hour + 3) % 24)}`;

// Next local occurrence of the slot's (day-of-week, start hour), for
// prefilling a datetime-local input.
export const nextSlotOccurrence = (slot) => {
  const d = new Date();
  d.setMinutes(0, 0, 0);
  d.setHours(slot.hour);
  let delta = (slot.day_of_week - d.getDay() + 7) % 7;
  if (delta === 0 && d <= new Date()) delta = 7;
  d.setDate(d.getDate() + delta);
  return d;
};

export const toLocalInputValue = (d) => {
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};
